import { DesignTokens } from '@workbuddy/theme';

export type DesignTone =
  | 'gray' | 'brand'
  | 'indigo' | 'fuchsia' | 'pink' | 'purple'
  | 'orangeDark' | 'blueLight' | 'moss';

export interface DesignToneTokens {
  soft: string;
  strong: string;
  solid: string;
  onSolid: string;
}

const utility = DesignTokens.componentColors.utility;

export const DesignTones: Record<DesignTone, DesignToneTokens> = {
  gray:       { soft: utility.gray100,       strong: utility.gray700,       solid: utility.gray500,       onSolid: utility.gray50 },
  brand:      { soft: utility.brand100,      strong: utility.brand700,      solid: utility.brand500,      onSolid: utility.brand50 },
  indigo:     { soft: utility.indigo100,     strong: utility.indigo700,     solid: utility.indigo500,     onSolid: utility.indigo50 },
  fuchsia:    { soft: utility.fuchsia100,    strong: utility.fuchsia700,    solid: utility.fuchsia500,    onSolid: utility.fuchsia50 },
  pink:       { soft: utility.pink100,       strong: utility.pink700,       solid: utility.pink500,       onSolid: utility.pink50 },
  purple:     { soft: utility.purple100,     strong: utility.purple700,     solid: utility.purple500,     onSolid: utility.purple50 },
  orangeDark: { soft: utility.orangeDark100, strong: utility.orangeDark700, solid: utility.orangeDark500, onSolid: utility.orangeDark50 },
  blueLight:  { soft: utility.blueLight100,  strong: utility.blueLight700,  solid: utility.blueLight500,  onSolid: utility.blueLight50 },
  moss:       { soft: utility.moss100,       strong: utility.moss700,       solid: utility.moss500,       onSolid: utility.moss50 },
};

export const ALL_DESIGN_TONES: DesignTone[] = Object.keys(DesignTones) as DesignTone[];

export function resolveDesignTone(tone: DesignTone | null | undefined): DesignToneTokens {

  return DesignTones[tone ?? 'indigo'] ?? DesignTones.indigo;
}
